import React from 'react';
import { Box, Grid, Paper, Typography, IconButton, Tooltip } from '@mui/material';
import { Favorite as FavoriteIcon } from '@mui/icons-material';
import { formatDuration } from '../../utils/timeUtils';

const PointageFavorites = ({ 
  favoritePointages, 
  onDuplicatePointage,
  onRemoveFavorite,
  formatFavoritePointageDetails 
}) => {
  // Fonction intégrée pour la couleur du texte
  const getTextColorForBackground = (backgroundColor) => {
    if (!backgroundColor) return '#000000';
    const hex = backgroundColor.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? '#000000' : '#ffffff';
  };

  return (
    <Grid container spacing={1}>
      {favoritePointages.map((pointage) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={pointage.id}>
          <Paper
            elevation={1}
            sx={{
              p: 1,
              backgroundColor: pointage.backgroundColor,
              color: getTextColorForBackground(pointage.backgroundColor),
              position: 'relative'
            }}
          >
            <IconButton
              size="small"
              sx={{ position: 'absolute', top: 4, right: 4, color: 'warning.main' }}
              onClick={(e) => {
                e.stopPropagation();
                onRemoveFavorite(pointage);
              }}
            >
              <FavoriteIcon fontSize="small" />
            </IconButton>

            <Box
              sx={{ cursor: 'pointer', '&:hover': { opacity: 0.9 } }}
              onClick={() => onDuplicatePointage(pointage)}
            >
              <Tooltip title={formatFavoritePointageDetails(pointage)}>
                <Box>
                  <Typography variant="subtitle2">
                    {formatDuration(pointage.hours)} - {pointage.releve_codes?.code}
                    {pointage.releve_codes?.role ? ` (${pointage.releve_codes.role})` : ''}
                  </Typography>
                  <Typography variant="body2">
                    {pointage.activities?.name}
                    {pointage.description ? ` : ${pointage.description}` : ''}
                  </Typography>
                </Box>
              </Tooltip>
            </Box>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default PointageFavorites;
